import { AnimatePresence, motion } from 'motion/react';
import { useBroadcast } from './hooks/useBroadcast';
// import { Advt } from './components/Advt/Advt';
import { Photo } from './components/Photo/Photo';

function App() {
  const { currentState, currentMessage } = useBroadcast();

  return (
    <div className="app-wrapper">
      <AnimatePresence>
        {/* {currentState === 'S1' && (
          <motion.div
            key="advt"
            style={{ width: '100%', height: '100%', position: 'fixed' }}
            exit={{ opacity: 0, transition: { duration: 1, delay: 0.5 } }}
            initial={{ opacity: 0 }}
            animate={{ opacity: 1, transition: { duration: 1 } }}
          >
            <Advt />
          </motion.div>
        )} */}
      </AnimatePresence>
      <AnimatePresence>
        {['S1', 'S2'].includes(currentState) && (
          <motion.div
            key="photo"
            style={{ width: '100%', height: '100%', position: 'fixed' }}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.5 }}
          >
            <Photo
              currentState={currentState}
              message={currentMessage?.message}
            />
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
}

export default App;
